import { Components } from '@/api/generated/api';
import { defineStore } from 'pinia';

export interface IWhoAmIState {
  whoAmI: Components.Schemas.WhoAmIDataDto | null;
}

export const useWhoAmIStore = defineStore('whoAmI', {
  actions: {
    setWhoAmI(whoAmI: Components.Schemas.WhoAmIDataDto): void {
      this.$patch((state) => {
        state.whoAmI = whoAmI;
      });
    },
  },

  state: (): IWhoAmIState => ({
    whoAmI: null,
  }),

  persist: true,
});
